module.exports = __webpack_public_path__ + "img/drag1.6a883554.svg";